import { useRef, useState } from 'react';
import { getProducts } from 'App/hexmodules/unexpectedStockOutflow/application/getProducts/getProducts.js'
import { getByProduct } from 'App/hexmodules/unexpectedStockOutflow/application/getByProduct/getByProduct'
import { useDependencies } from 'App/DependencyContext';

const STATE = {
  INITIAL: 'initial',
  FETCHING_PRODUCTS: 'fetchingProducts',
  FETCHED_PRODUCTS: 'fetchedProducts',
  ERROR_FETCHING_PRODUCTS: 'errorFetchingProducts',
};

function useUnexpectedStockOutflowList() {
  const state = useRef(STATE.INITIAL);
  const [products, setProducts] = useState([])
  const [unexpectedStocks, setUnexpectedStocks] = useState([])
  const { unexpectedStockOutflowRepository } = useDependencies()

  const fetchProducts = async () => {
    try {
      const data = await getProducts(unexpectedStockOutflowRepository);
      console.log(data)
      setProducts(data)
    } catch (error) {
      throw new Error(error.message || 'Error al obtener la lista de productos de salidas inesperadas')
    }
  }

  const fetchUnexpectedStockOutflowByProduct = async ({ idProducto, fechaInicio, fechaFin }) => {
    try {
      const data = await getByProduct(unexpectedStockOutflowRepository, { idProducto, fechaInicio, fechaFin });
      setUnexpectedStocks(data)
    } catch (error) {
      throw new Error(error?.message || 'Error al obtener la lista de productos de salidas inesperadas')
    }
  }

  const initialFetch = async () => {
    if (state.current === STATE.INITIAL) {
      state.current = STATE.FETCHING_PRODUCTS;
      await fetchProducts();
      state.current = STATE.FETCHED_PRODUCTS;
    }
  };

  initialFetch();

  return {
    products,
    unexpectedStocks,
    refreshProducts: fetchProducts,
    refreshUnexpectedStockOutflowByProduct: fetchUnexpectedStockOutflowByProduct,
  };
}

export default useUnexpectedStockOutflowList; 